import { render, staticRenderFns } from "./UserDev.vue?vue&type=template&id=18ca5a1f&scoped=true&"
import script from "./UserDev.vue?vue&type=script&lang=js&"
export * from "./UserDev.vue?vue&type=script&lang=js&"
import style0 from "./UserDev.vue?vue&type=style&index=0&id=18ca5a1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ca5a1f",
  null
  
)

export default component.exports